import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';

import DashboardPage from './pages/DashboardPage';
import DirectoryPage from './pages/DirectoryPage';
import DocumentsPage from './pages/DocumentsPage';
import HRPage from './pages/HRPage';
import ProfilePage from './pages/ProfilePage';
import EventCalendarPage from './pages/EventCalendarPage';
import InnovationPage from './pages/InnovationPage';
import AdministrativePage from './pages/AdministrativePage';
import SelfServicePage from './pages/SelfServicePage';
import InventoryPage from './pages/InventoryPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import ChatWidget from './components/ChatWidget';
import SurveyPage from './pages/SurveyPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import BasvurularPage from './pages/BasvurularPage';
import YeniCalisanPage from './pages/YeniCalisanPage';
import TumCalisanlarPage from './pages/TumCalisanlarPage';
import IdariIslerTaleplerimPage from './pages/IdariIslerTaleplerimPage';
import IdariIslerIstatistiklerPage from './pages/IdariIslerIstatistiklerPage';
import ZimmetListesiPage from './pages/ZimmetListesiPage';
import YeniZimmetPage from './pages/YeniZimmetPage';
import ZimmetRaporlariPage from './pages/ZimmetRaporlariPage';
import {
  LEGACY_ROUTE_REDIRECTS,
  ROUTE_PATHS
} from './config/navigation';

const APP_ROUTES = [
  { path: ROUTE_PATHS.dashboard, element: <DashboardPage /> },
  { path: ROUTE_PATHS.announcements, element: <AnnouncementsPage /> },
  { path: ROUTE_PATHS.directory, element: <DirectoryPage /> },
  { path: ROUTE_PATHS.documents, element: <DocumentsPage /> },
  { path: ROUTE_PATHS.hr, element: <HRPage /> },
  { path: ROUTE_PATHS.applications, element: <BasvurularPage />, roles: ['admin', 'manager'] },
  { path: ROUTE_PATHS.newEmployee, element: <YeniCalisanPage />, roles: ['admin', 'manager'] },
  { path: ROUTE_PATHS.allEmployees, element: <TumCalisanlarPage />, roles: ['admin', 'manager'] },
  { path: ROUTE_PATHS.profile, element: <ProfilePage /> },
  { path: ROUTE_PATHS.events, element: <EventCalendarPage /> },
  { path: ROUTE_PATHS.surveys, element: <SurveyPage /> },
  { path: ROUTE_PATHS.innovation, element: <InnovationPage /> },
  { path: ROUTE_PATHS.administrative, element: <AdministrativePage /> },
  { path: ROUTE_PATHS.selfService, element: <SelfServicePage /> },
  { path: ROUTE_PATHS.administrativeRequests, element: <IdariIslerTaleplerimPage /> },
  { path: ROUTE_PATHS.administrativeStats, element: <IdariIslerIstatistiklerPage /> },
  { path: ROUTE_PATHS.inventory, element: <InventoryPage /> },
  { path: ROUTE_PATHS.inventoryList, element: <ZimmetListesiPage /> },
  { path: ROUTE_PATHS.newInventory, element: <YeniZimmetPage /> },
  { path: ROUTE_PATHS.inventoryReports, element: <ZimmetRaporlariPage /> }
];

const ProtectedLayout = () => (
  <ProtectedRoute>
    <>
      <Sidebar />
      <Header />
      <div className="main">
        <div className="main-content">
          <Routes>
            {APP_ROUTES.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  route.roles ? (
                    <ProtectedRoute roles={route.roles}>{route.element}</ProtectedRoute>
                  ) : (
                    route.element
                  )
                }
              />
            ))}
            <Route path="*" element={<Navigate to={ROUTE_PATHS.dashboard} replace />} />
          </Routes>
        </div>
      </div>

      <div className="overlay"></div>
      <ChatWidget />
    </>
  </ProtectedRoute>
);

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <div className="App">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path={ROUTE_PATHS.login} element={<LoginPage />} />
          {LEGACY_ROUTE_REDIRECTS.map((redirect) => (
            <Route
              key={redirect.from}
              path={redirect.from}
              element={<Navigate to={redirect.to} replace />}
            />
          ))}
          <Route path="/*" element={<ProtectedLayout />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
